import {useState} from 'react'
import {Modal} from 'react-bootstrap'

import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'

export function DeleteCellModal(props: any) {
  return (
    <div>
      <ToastMessageContainer />
      <Modal
        show={props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-50w'
        // onHide={() => props.closeModal(false)}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton>
          <span className='fs-3 fw-bold'>Alert</span>
        </Modal.Header>
        <Modal.Body className='container' />
        <div className='ePulse-modal-content'>
          <span className='fs-3 fw-semibold ms-4'>
            Are you sure, you want to Add or Delete Column?
          </span>
          <div className='btn-row'>
            <button className='ePulse-btn-primary' type='button' onClick={() => props.onCancel()}>
              cancel
            </button>
            <button className='ePulse-btn-primary' type='button' onClick={() => props.onDelete()}>
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
